import { useReactiveVar } from '@apollo/client';

import {
  CurrentCustomerAdminFragment,
  CurrentTenantAdminFragment,
} from '@/types/graphql';
import { currentAdminVar, currentAgencyVar } from '@/util/apollo/cache';
import { isClientAdminUser, isTenantAdminUser } from '@/util/adminRole';

const useAuth = () => {
  const currentAgency = useReactiveVar(currentAgencyVar);

  // Adding this typeguard to ensure if customer is a property of currentAdmin object.
  const isCurrentCustomerAdmin = (
    arg: CurrentCustomerAdminFragment | CurrentTenantAdminFragment | null,
  ): arg is CurrentCustomerAdminFragment =>
    (arg as CurrentCustomerAdminFragment).customer !== undefined;

  const currentAdmin = useReactiveVar(currentAdminVar);
  const currentAdminIsCustomerAdmin = isClientAdminUser(currentAdmin);
  // Strict tenant-admin check (helpdesk admins excluded too) — gates
  // GravyWork-internal cost signals like the OT risk banner and the
  // "Hours This Week" staffing column. Keyed on `user.roleId`, what graphy's
  // `require_tenant_admin_role` checks; see util/adminRole for why `role`
  // (graphy's TenantRole level) must not be used.
  const currentAdminIsTenantAdmin = isTenantAdminUser(currentAdmin);

  return {
    currentAdmin,
    currentAdminIsCustomerAdmin,
    currentAdminIsTenantAdmin,
    isCurrentCustomerAdmin,
    currentAgency,
  };
};

export default useAuth;
